import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMic = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.75,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M12 19v3" }),
		/* @__PURE__ */ _jsx("path", { d: "M19 10v2a7 7 0 0 1-14 0v-2" }),
		/* @__PURE__ */ _jsx("rect", {
			x: 9,
			y: 2,
			width: 6,
			height: 13,
			rx: 3
		})
	]
});
const ForwardRef = forwardRef(SvgMic);
export default ForwardRef;
